module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAFAQMAAACOxgX9AAAABlBMVEX///+7u7vHS9/4AAAAAXRSTlMAQObYZgAAABJJREFUCB1j/M/A8JABBBhRWQBHHQWk2zGZQgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/grippie.png
// module id = 202
// module chunks = 0